import { IconAssets } from '../../utils/enums/assets';
import { Scenes } from '../../utils/enums/scenes';
import { SceneData } from '../../utils/types/scene';
import { WithScoreScene } from '../classes/WithScoreScene';
import { UI } from '../ui/ui';

export class EndGame extends WithScoreScene {
  sceneData: SceneData;

  constructor() {
    super(Scenes.END_GAME);
  }

  init(data: SceneData) {
    this.sceneData = data;
    this.user = data.user;
  }

  preload() {
    this.load.image(IconAssets.AVATAR_ICON, './assets/icons/avatar-sample.png');
  }

  create() {
    this.input.setDefaultCursor('default');
    this.renderBackground();
    this.renderTexts();
    this.renderTopPlayers();
    this.renderButtons();
    this.renderIcons();
  }

  update() {
    this.updateTopPlayersUi();
  }

  private renderBackground() {
    UI.images.Background(this);
  }

  private renderTexts() {
    UI.text.WinGameMsg(this);
    UI.text.Level(this, this.sceneData?.level);
    UI.text.EndGameScore(this);
    UI.text.HighScores(this);
  }

  private renderTopPlayers() {
    this.topPlayersUi = UI.components.TopPlayers(this);
  }

  private renderButtons() {
    UI.buttons.EndGameRestart(this, () => {
      this.scene.stop();
      this.resetApiFlags();
      this.scene.start(Scenes.GAME, { user: this.user });
    });

    UI.icons.HomeIcon(this, { interactive: true }).on('pointerdown', () => {
      this.scene.stop();
      this.resetApiFlags();
      this.scene.start(Scenes.EXIT_GAME, { user: this.user });
    });
  }

  private renderIcons() {
    UI.icons.FullScreenIcon(this);
  }
}
